<div class="container-fluid p-0" [formGroup]="OwnerFormGroup">
  <!-- Identity -->
  <div class="row g-3">
    <div class="col-md-3">
      <div class="form-group mb-0">
        <label class="form-label" requiredAsterisk for="owner-firstName">
          First name
        </label>
        <input
          id="owner-firstName"
          type="text"
          class="form-control"
          formControlName="firstName"
        />
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group mb-0">
        <label class="form-label" requiredAsterisk for="owner-lastName">
          Last name
        </label>
        <input
          id="owner-lastName"
          type="text"
          class="form-control"
          formControlName="lastName"
        />
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group mb-0">
        <label class="form-label" requiredAsterisk for="owner-phone">
          Phone
        </label>
        <input
          id="owner-phone"
          type="text"
          class="form-control"
          formControlName="phone"
          placeholder="(___) ___-____"
          [inputMask]="phoneMask"
        />
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group mb-0">
        <label class="form-label" for="owner-ssn">
          @if (
            isEditMode && hasOwnerSSNAccess && ownerHasSSN && !revealedOwnerSSN
          ) {
            SSN (first 5)
          } @else {
            SSN (first 5)
          }
        </label>
        @if (
          isEditMode && hasOwnerSSNAccess && ownerHasSSN && !revealedOwnerSSN
        ) {
          <button
            type="button"
            class="btn btn-outline w-100"
            (click)="viewOwnerSSN()"
          >
            View SSN
          </button>
        } @else if (
          !isEditMode ||
          (hasOwnerSSNAccess && (!ownerHasSSN || revealedOwnerSSN))
        ) {
          <input
            id="owner-ssn"
            type="text"
            class="form-control"
            formControlName="ssn"
            placeholder="___-__"
            [inputMask]="ssnFirst5DigitMask"
          />
        } @else {
          <input type="text" class="form-control" value="XXX-XX" disabled />
        }
      </div>
    </div>
  </div>

  <!-- Residence + DOB + ownership -->
  <div class="row g-3 mt-1">
    <div class="col-md-3">
      <div class="form-group mb-0">
        <label class="form-label" requiredAsterisk>State of residence</label>
        <app-select-dropdown
          [options]="SubNationalDivisions"
          [control]="OwnerFormGroup.controls['Address'].controls['state']"
          [dropdownId]="'stateOfResidenceDropdown'"
          placeholder=""
        ></app-select-dropdown>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group mb-0">
        <label class="form-label" requiredAsterisk for="owner-dob">
          Date of birth
        </label>
        <div class="input-group">
          <input
            id="owner-dob"
            class="form-control"
            type="text"
            placeholder="MM/DD/YYYY"
            formControlName="dob"
            navigation="select"
            [maxDate]="maxDatePickerDate"
            [minDate]="minDatePickerDate"
            ngbDatepicker
            container="body"
            #dobDatePicker="ngbDatepicker"
            appNgbDateInputMask
          />
          <button
            type="button"
            class="btn datepicker-button"
            (click)="dobDatePicker.toggle()"
            aria-label="Open calendar"
          >
            <i class="bi bi-calendar"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group mb-0">
        <label class="form-label" requiredAsterisk for="owner-percent">
          Ownership %
        </label>
        <input
          id="owner-percent"
          type="text"
          class="form-control"
          [inputMask]="ownerPercentMask"
          formControlName="percentOwner"
        />
      </div>
    </div>
    @if (showLexisNexisId) {
      <div class="col-md-3">
        <div class="form-group mb-0">
          <label class="form-label" for="owner-lexisNexisId">
            Lexis Nexis ID
          </label>
          <input
            id="owner-lexisNexisId"
            type="text"
            class="form-control"
            formControlName="LexisNexisId"
          />
        </div>
      </div>
    }
  </div>

  <!-- Address — separated by a hairline so the eye can read it as its
       own section. -->
  <hr class="owner-edit-divider" />

  <app-address-form
    [addressForm]="OwnerFormGroup.controls['Address']"
    [country]="country!"
    [defaultLayout]="'horizontal'"
    [useMailingAddressTemplate]="false"
    [useStreetAddressTemplate]="false"
  ></app-address-form>

  @if (showSaveButton) {
    <div class="action-row justify-end mt-4 pt-3 border-top">
      <button type="button" class="btn btn-primary" (click)="save()">
        Save owner
      </button>
    </div>
  }
</div>
